import React, { useState, useEffect, useRef } from 'react'
import TopSection from '../components/TopSection'
import { useLoading } from '../context/LoadingContext';
import axios from 'axios';
import Select from 'react-select';
import { Modal, Button, Row, Col, Table } from "react-bootstrap";
import ToastNotification from '../components/ToastNotification';

const Careers = () => {
    const formRef = useRef(null);

    const { setLoading } = useLoading();
    const [postList, setPostList] = useState([]);
    const [form, setForm] = useState({
        title: '',
        first: '',
        middle: '',
        last: "",
        emp_id: "",
        emp_code: '',
        phone: '',
        extension: '',
        email: '',
        dob: '',
        confirmed: '',
        gender: '',
        job_status: '',
        designation: '',
        department: '',
        address: '',
        city: '',
        pin: '',
        state: '',
        bank_name: '',
        bank_acc: '',
        bank_branch: '',
        ifsc: '',
        esic: '',
        reporting: '',
        weekly_off: '',
        basic: '',
        marital_status: '',
        doj: '',
        seperation_date: '',
        pf_no: '',
        alt_first: '',
        alt_second: '',
        region: '',
        lic: "",
        mediclaim_no: '',
        role: '',
        branch: '',

        medical_info: '',
        medical_condition: '',
        blood_grp: '',
        alergies: '',
        phoneChecked: false,
        phoneChecked_one: false,
        phoneChecked_two: false,

        pincode_two: '',
        state_two: '',
        city_two: '',
        region_two: '',
        address_two: '',


    });

    const titleOptions = [
        { value: '1', label: 'Mrs.' },
        { value: '2', label: 'Mr.' },
        { value: '3', label: 'Ms.' },
    ]

    const [rows, setRows] = useState([
        {
            employer: "",
            designation: "",
            doj: "",
            leftOn: "",
            joiningSalary: "",
            lastSalary: "",
        employerno:'',
        expereinceCertificate:''
        },
    ]);

    const [educationRows, setEducationRows] = useState([
        {
            exam: "",
            board: "",
            passingYear: "",
            percentage: "",
            certificate: null,
        },
    ]);

    const genderOptions = [
        { value: '1', label: 'Male' },
        { value: '2', label: 'Female' },
        { value: '3', label: 'Other' }
    ]

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    const fetchOpenings = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/get-openings');
            setPostList(res.data);
        } catch (error) {
            console.error("Error fetching Notices", error);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchOpenings();
    }, [])

    const [showForm, setShowForm] = useState(false);

    const handleAddClick = (role) => {
        setShowForm(true);
        setForm({
            role: role
        })
        setTimeout(() => {
            formRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }, 100);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
            // ...(isEditMode && name === "phone" ? { phoneChecked: false } : {}),
            // ...(isEditMode && name === "alt_first"? {phoneChecked_one :false} :{}),
            // ...(isEditMode && name === "alt_second" ? {phoneChecked_two :false} : {} ),
        }));
    };


    const handleAddEducationRow = () => {
        setEducationRows([
            ...educationRows,
            {
                exam: "",
                board: "",
                passingYear: "",
                percentage: "",
                certificate: null,
            },
        ]);
    };

    // 🗑️ Delete an education row
    const handleDeleteEducationRow = (index) => {
        const updated = educationRows.filter((_, i) => i !== index);
        setEducationRows(updated);
    };

    // ✏️ Handle input changes
    const handleEducationChange = (index, field, value) => {
        const updated = [...educationRows];
        updated[index][field] = value;
        setEducationRows(updated);
    };

    // 📁 Handle file upload
    const handleFileRowChange = (index, file) => {
        const updated = [...educationRows];
        updated[index].certificate = file;
        setEducationRows(updated);
    };

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };


 const handleExpCertificateChange = (index, key, file) => {
    const updated = [...rows];
    updated[index][key] = file; // dynamically set key
    setRows(updated);
};
    const handlePincodeCheck = async () => {
        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/check?pincode=${form.pin}`
            );


            const data = response.data;


            setForm({
                ...form,
                city: data.city,
                state: data.state,
                region: data.region
            });
        } catch (error) {


            if (error.response && error.response.status === 404) {
                showToast("❌ Pincode not found !", 'danger');
            } else {
                showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
            }
            console.error("Error checking pincode:", error);
            setForm({
                ...form,
                city: "",
                state: "",
                region: ""
            });
        }
    };


    const handlePincodeCheckParmanent = async () => {
        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/checkPermanent?pincode=${form.pincode_two}`
            );


            const data = response.data;
            console.log(data)

            setForm({
                ...form,
                city_two: data.city_two,
                state_two: data.state_two,
                region_two: data.region_two
            });
        } catch (error) {


            if (error.response && error.response.status === 404) {
                showToast("❌ Pincode not found !", 'danger');
            } else {
                showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
            }
            console.error("Error checking pincode:", error);
            setForm({
                ...form,
                city_two: "",
                state_two: "",
                region_two: ""
            });
        }
    };

    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                employer: "",
                designation: "",
                doj: "",
                leftOn: "",
                joiningSalary: "",
                lastSalary: "",
                 employerno:'',
        expereinceCertificate:''
            },
        ]);
    };

    const handleDeleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };



const handleSubmit = async (e) => {
    e.preventDefault();

 
    // if (!rows || rows.length === 0) {
    //     showToast("Please add at least one employment history row.", "warning");
    //     return; 
    // }

    const isExperienceValid = rows.some(row =>
  row.employer?.trim() ||
  row.designation?.trim() ||
  row.doj ||
  row.leftOn ||
  row.joiningSalary ||
  row.lastSalary
);

if (!isExperienceValid) {
  showToast("Please fill at least one valid employment history row.", "warning");
  return;
}


    // if (!educationRows || educationRows.length === 0) {
    //     showToast("Please add at least one education row.", "warning"); 
    //     return; 
    // }

    const isEducationValid = educationRows.some(row =>
  row.exam?.trim() ||
  row.board?.trim() ||
  row.passingYear ||
  row.percentage ||
  row.certificate
);

if (!isEducationValid) {
  showToast("Please fill at least one valid education row.", "warning");
  return;
}


    const safe = (value) => value ?? '';

    // Create FormData
    const sendData = new FormData();
    sendData.append("title", safe(form.title));
    sendData.append("first", safe(form.first));
    sendData.append("middle", safe(form.middle));
    sendData.append("last", safe(form.last));
    sendData.append("phone", safe(form.phone));
    sendData.append("extension", safe(form.extension));
    sendData.append("email", safe(form.email));
    sendData.append("dob", safe(form.dob));
    sendData.append("confirmed", safe(form.confirmed));
    sendData.append("gender", safe(form.gender));
    sendData.append("job_status", safe(form.job_status));
    sendData.append("designation", safe(form.designation));
    sendData.append("department", safe(form.department));
    sendData.append("address", safe(form.address));
    sendData.append("city", safe(form.city));
    sendData.append("pin", safe(form.pin));
    sendData.append("state", safe(form.state));
    sendData.append("bank_name", safe(form.bank_name));
    sendData.append("bank_acc", safe(form.bank_acc));
    sendData.append("bank_branch", safe(form.bank_branch));
    sendData.append("ifsc", safe(form.ifsc));
    sendData.append("esic", safe(form.esic));
    sendData.append("reporting", safe(form.reporting));
    sendData.append("weekly_off", safe(form.weekly_off));
    sendData.append("basic", safe(form.basic));
    sendData.append("marital_status", safe(form.marital_status));
    sendData.append("doj", safe(form.doj));
    sendData.append("seperation_date", safe(form.seperation_date));
    sendData.append("pf_no", safe(form.pf_no));
    sendData.append("alt_first", safe(form.alt_first));
    sendData.append("alt_second", safe(form.alt_second));
    sendData.append("region", safe(form.region));
    sendData.append("lic", safe(form.lic));
    sendData.append("mediclaim_no", safe(form.mediclaim_no));
    sendData.append("role", safe(form.role));
    sendData.append("branch", safe(form.branch));
    sendData.append("medical_info", safe(form.medical_info));
    sendData.append("medical_condition", safe(form.medical_condition));
    sendData.append("blood_grp", safe(form.blood_grp));
    sendData.append("alergies", safe(form.alergies));
    sendData.append("phoneChecked", form.phoneChecked ? form.phoneChecked : '');
    sendData.append("phoneChecked_one", form.phoneChecked_one ? form.phoneChecked_one : '');
    sendData.append("phoneChecked_two", form.phoneChecked_two ? form.phoneChecked_two : '');
    sendData.append("pincode_two", safe(form.pincode_two));
    sendData.append("state_two", safe(form.state_two));
    sendData.append("city_two", safe(form.city_two));
    sendData.append("region_two", safe(form.region_two));
    sendData.append("address_two", safe(form.address_two));

    sendData.append("employment_history", JSON.stringify(rows));

    sendData.append(
        "education_details",
        JSON.stringify(
            educationRows.map(e => ({
                ...e,
                certificate: ""
            }))
        )
    );

    educationRows.forEach((row, index) => {
        if (row.certificate) {
            sendData.append(`certificate_${index}`, row.certificate);
        }
    });

//     rows.forEach((row, idx) => {
//     if (row.expereinceCertificate) {
//         sendData.append(`expereinceCertificate_${idx}`, row.expereinceCertificate);
//     }
// });

    sendData.append("family_members", '');

    try {
        const res = await axios.post(
            "https://api.skyguard.group/api/add-application",
            sendData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );

        setShowForm(false);
        showToast('Role Applied successfully!', 'success');
    } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
        showToast('Failed to add Employee!', 'danger');
    }

    // Reset form and tables
    setForm({
        title: '', first: '', middle: '', last: '',
        emp_id: '', emp_code: '', phone: '', extension: '',
        email: '', dob: '', confirmed: '', gender: '', job_status: '',
        designation: '', department: '', address: '', city: '',
        pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
        ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
        marital_status: '', doj: '', seperation_date: '', pf_no: '',
        role: '', region: '', alt_first: '', alt_second: '',
        lic: '', mediclaim_no: '', branch: '', medical_info: '',
        medical_condition: '', blood_grp: '', alergies: '', 
        pincode_two: '', state_two: '', city_two: '', region_two: '', address_two: '',
    });
    setRows([]);
    setEducationRows([]);
};



    return (
        <>
            <TopSection title='Careers' breadcrumb='Careers' />

            <section className='my-5'>
                <div className='container'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <h2 className='fw-bold text-dark'>
                        Openings at SKYGUARD
                    </h2>
                    <p className='fw-medium'>Explore new opportunities. Become a part of our Team.</p>

                    {postList.length > 0 ? (
                        postList.map((notice, idx) => (
                            <div className='border rounded-3 p-4 my-3'>
                                <p className='fs-5 fw-bold'>{notice.role}</p>
                                <p>
                                    <span className='ms-2 bg-warning p-2 rounded-4 fw-semibold'>Posted on: {new Date(notice.date).toLocaleDateString('en-GB')}</span>
                                    <span className='ms-2 bg-light p-2 rounded-4 fw-semibold border'>Experience: {notice.exp}</span>
                                </p>


                                <p>{notice.description
                                    .split('|')
                                    .map((text, index) => (
                                        <div key={index}>● {text.trim()}</div>
                                    ))}</p>

                                <button className='btn btn-success' onClick={() => handleAddClick(notice.role)}>Apply Now</button>
                            </div>
                        ))) : (
                        <div className='my-5'>
                            <p className='fw-medium'>New Openings will be listed here.</p>
                        </div>
                    )}

                    {showForm && (


                        <div className='card p-3 mb-3' ref={formRef}>
                            <form onSubmit={handleSubmit} >

                                <h5 className="mt-1 fs-4 text-center fw-semibold text-primary">Basic Info</h5>

                                <hr />

                                <div className='row g-3'>
                                    {/* Title */}
                                    <div className="col-md-4">
                                        <label htmlFor="title" className="form-label fw-medium">Select Title</label>

                                        <Select
                                            options={titleOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={titleOptions.find(option => option.label === form.title)}
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, title: selectedOption.label })
                                            }
                                        />

                                    </div>
                                    {/* First Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium" >First Name  <span className="text-danger fs-4 ">*</span> </label>
                                        <input type="text" className="form-control" name="first" placeholder="Enter here..." value={form.first} onChange={handleInputChange} required />
                                    </div>


                                    {/* Middle Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='middle' className="form-label fw-medium" >Middle Name</label>
                                        <input type="text" className="form-control" name="middle" placeholder="Enter here..."
                                            value={form.middle}
                                            onChange={handleInputChange}

                                        />
                                    </div>
                                    {/* Last Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='last' className="form-label fw-medium" >Last Name</label>
                                        <input type="text" className="form-control" name="last" placeholder="Enter here..."
                                            value={form.last}
                                            onChange={handleInputChange}
                                        />
                                    </div>



                                    <div className="col-md-4">
                                        <label htmlFor="phone" className="form-label fw-medium">Phone No. <span className="text-danger fs-4">*</span></label>

                                        {/* Phone input */}
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="phone"
                                            placeholder="Enter here..."
                                            value={form.phone}
                                            onChange={handleInputChange}
                                            required
                                            maxLength={10}
                                        />

                                    </div>



                                    {/* Email ID */}
                                    <div className="col-md-4">
                                        <label htmlFor='email' className="form-label fw-medium" >Email ID <span className="text-danger fs-4">*</span></label>
                                        <input type="text" className="form-control" name="email" placeholder="Enter here..." value={form.email} onChange={handleInputChange} required />
                                    </div>
                                    {/* DOB */}
                                    <div className="col-md-4">
                                        <label htmlFor="dob" className="form-label fw-medium">DOB</label>
                                        <input type="date" className="form-control" name="dob"
                                            value={form.dob}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* Gender */}
                                    <div className="col-md-4">
                                        <label htmlFor="gender" className="form-label fw-medium">Select Gender</label>

                                        <Select
                                            options={genderOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={genderOptions.find(option => option.label === form.gender)} 
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, gender: selectedOption.label }) 
                                            }
                                        />

                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor='role' className="form-label fw-medium" >Applying For</label>
                                        <input type="text" className="form-control" name="role" placeholder="Enter here..."
                                            value={form.role}
                                            onChange={handleInputChange}
                                            disabled
                                        />
                                    </div>


                                    <div className="mt-4">
                                        <h5 className='mt-1 fs-4 text-center fw-semibold text-primary'>Address Detail</h5>
                                        <hr />

                                        <div className="row">
                                            <h4 className='fw-semibold text-success'>Present Address</h4>
                                            <div className='col-md-4 '>



                                                <div className="d-flex align-items-end gap-2">


                                                    <div className='flex-grow-1 '>
                                                        <label>Pincode</label>


                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='pin'
                                                            value={form.pin}
                                                            placeholder='Pincode'
                                                            onChange={handleInputChange}

                                                            required
                                                        />
                                                    </div>

                                                    <button className='btn btn-primary'
                                                        type="button"
                                                        onClick={handlePincodeCheck}
                                                    >OK </button>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">State</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="state"
                                                    value={form.state}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">City</label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city"
                                                    value={form.city}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Region</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="region"
                                                    value={form.region}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Address</label>
                                                <textarea
                                                    className="form-control"
                                                    name="address"
                                                    placeholder="Enter here..."
                                                    value={form.address}
                                                    onChange={handleInputChange}
                                                    rows={4}
                                                />
                                            </div>


                                        </div>




                                        <div className="row">
                                            <h4 className='fw-semibold text-success mt-3'>Permanent Address</h4>
                                            <div className='col-md-4 '>



                                                <div className="d-flex align-items-end gap-2">


                                                    <div className='flex-grow-1 '>
                                                        <label>Pincode</label>


                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='pincode_two'
                                                            value={form.pincode_two}
                                                            placeholder='Pincode'
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>

                                                    <button className='btn btn-primary'
                                                        type="button"
                                                        onClick={handlePincodeCheckParmanent}
                                                    >OK </button>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">State</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="state_two"
                                                    value={form.state_two}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">City</label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city_two"
                                                    value={form.city_two}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Region</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="region_two"
                                                    value={form.region_two}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Address</label>
                                                <textarea
                                                    className="form-control"
                                                    name="address_two"
                                                    placeholder="Enter here..."
                                                    value={form.address_two}
                                                    onChange={handleInputChange}
                                                    rows={4}
                                                />
                                            </div>


                                        </div>





                                    </div>



                                    {/* Education and Experience */}
                                    <h5 className="mt-4 fs-4 text-center fw-semibold text-primary">Education & Experience</h5>
                                    <hr />
                                    <div className="row g-3">
                                        <div className="table-responsive my-4">

                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5>Experience <span className="text-danger">*</span> </h5>
                                                <Button variant="success" size="sm" onClick={handleAddRow}>
                                                    ➕ Add
                                                </Button>
                                            </div>


                                            <Table bordered responsive className="text-center align-middle">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>Employer</th>
                                                        <th>Designation</th>
                                                        <th>DOJ</th>
                                                        <th>Left On</th>
                                                        <th>Joining Salary</th>
                                                        <th>Last Salary /Expexted Salary</th>
                                                        {/* <th>Last Employer No</th>
                                                        <th>Experience Certificate</th> */}
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.employer}
                                                                        onChange={(e) =>
                                                                            handleChange(index, "employer", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.designation}
                                                                        onChange={(e) =>
                                                                            handleChange(index, "designation", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={row.doj}
                                                                        onChange={(e) => handleChange(index, "doj", e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={row.leftOn}
                                                                        onChange={(e) =>
                                                                            handleChange(index, "leftOn", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.joiningSalary}
                                                                        onChange={(e) =>
                                                                            handleChange(index, "joiningSalary", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.lastSalary}
                                                                        onChange={(e) =>
                                                                            handleChange(index, "lastSalary", e.target.value)
                                                                        }
                                                                    />
                                                                </td>

                                                                {/* <td> 
                                                                    < input type='number' className='form-control' 
                                                                    value={row. employerno}
                                                                  onChange={(e) =>
                                                                            handleChange(index, "employerno", e.target.value)
                                                                        }

                                                                    />
                                                                </td>
                                                                    <td> 
                                                                    < input type='file' className='form-control'
                                                                     accept=".pdf,.jpg,.jpeg,.png" 
                                                              
                                                                  onChange={(e) =>
                                                                            handleExpCertificateChange(index, "expereinceCertificate",  e.target.files[0])
                                                                        }

                                                                    />
                                                                </td> */}
                                                                <td>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleDeleteRow(index)}
                                                                    >
                                                                        🗑️ Delete
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-muted">
                                                                No rows added yet.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>

                                        </div>



                                        <div className="table-responsive my-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5>Education Details <span className="text-danger">*</span></h5>
                                                <Button variant="success" size="sm" onClick={handleAddEducationRow}>
                                                    ➕ Add
                                                </Button>
                                            </div>

                                            <Table bordered responsive className="text-center align-middle">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>Exam</th>
                                                        <th>Board / University</th>
                                                        <th>Passing Year</th>
                                                        <th>Percentage</th>
                                                        <th>Certificate Upload</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {educationRows.length > 0 ? (
                                                        educationRows.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.exam}
                                                                        onChange={(e) =>
                                                                            handleEducationChange(index, "exam", e.target.value)
                                                                        }
                                                                        placeholder="e.g. 10th / 12th / BSc"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.board}
                                                                        onChange={(e) =>
                                                                            handleEducationChange(index, "board", e.target.value)
                                                                        }
                                                                        placeholder="e.g. CBSE / Mumbai Univ."
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.passingYear}
                                                                        onChange={(e) =>
                                                                            handleEducationChange(index, "passingYear", e.target.value)
                                                                        }
                                                                        placeholder="e.g. 2022"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.percentage}
                                                                        onChange={(e) =>
                                                                            handleEducationChange(index, "percentage", e.target.value)
                                                                        }
                                                                        placeholder="e.g. 85"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                                        onChange={(e) =>
                                                                            handleFileRowChange(index, e.target.files[0])
                                                                        }
                                                                    />

                                                                    {row.certificate && typeof row.certificate === 'string' && (
                                                                        <span>{row.certificate.split('/').pop()}</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleDeleteEducationRow(index)}
                                                                    >
                                                                        🗑️ Delete
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" className="text-muted">
                                                                No education records added yet.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>


                                    </div>




                                    {/* ====================================save & cancel======================================= */}

                                    <div className='gap-2 d-flex justify-content-center mt-4'>
                                        <button type="submit" className='btn btn-success w-10'>
                                            SAVE
                                        </button>
                                        <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                            setShowForm(false);
                                            setForm({
                                                title: '', first: '', middle: '', last: '',
                                                emp_id: '', emp_code: '', phone: '', extension: '',
                                                email: '', dob: '', confirmed: '', gender: '', job_status: '',
                                                designation: '', department: '', address: '', city: '',
                                                pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
                                                ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
                                                marital_status: '', doj: '', seperation_date: '', pf_no: '',
                                                role: '', region: '', alt_first: '', alt_second: '',
                                                lic: '', mediclaim_no: '', pincode_two: '', state_two: '', city_two: '', region_two: '', address_two: '',
                                            });
                                            setRows([]);
                                            setEducationRows([]);
                                        }}>
                                            Cancel
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    )}

                </div>
            </section>

        </>
    )
}

export default Careers